/* eslint-disable max-len -- ignored for api keys */
import { SharedConfig } from '@shared/SharedConfig';

const environment = process.env.REACT_APP_ENVIRONMENT || '';
const devel = environment.includes('devel');
const local = !environment;
const prod = environment.includes('prod');
const staging = environment.includes('staging');
const uat = environment.includes('uat');

const shortUrlDomain = process.env.REACT_APP_SHORT_URL_DOMAIN ?? SharedConfig.shortUrlDomain;

const isLoyaltyProgramDomain = window.location.hostname.includes(shortUrlDomain);

export const AppConfig = {
  biddingApiUrl: isLoyaltyProgramDomain
    ? process.env.REACT_APP_LOYALTY_API_URL ?? "http://localhost:3010"
    : process.env.REACT_APP_API_URL ?? "http://localhost:3010",
  desktopBreakpoint: "sm",
  env: {
    devel,
    local,
    prod,
    staging,
    test: local || devel || staging || uat,
    uat,
  },
  mobileBreakpoint: "xs",
  shortUrlDomain,
  staticImageHost: process.env.REACT_APP_STATIC_ASSETS_HOST?.includes('https')
    ? process.env.REACT_APP_STATIC_ASSETS_HOST
    : (process.env.REACT_APP_STATIC_ASSETS_HOST ? `https://${process.env.REACT_APP_STATIC_ASSETS_HOST}` : ''),
  version: SharedConfig.version,
};
